import {
  IsNotEmpty,
  IsOptional,
  IsArray,
  IsNumber,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";
import { RunningOrderDto } from "./running-order.dto";
import { IShowRing } from "./show-ring.interface";

export class ShowRingDto implements IShowRing {
  @IsNotEmpty()
  ring: string;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => RunningOrderDto)
  running_order?: RunningOrderDto[];

  @IsOptional()
  @IsNumber()
  start_offset_minutes?: number;
}
